// Module
var code = `<loading-indicator ng-if="!\$ctrl.isVisible" type="{{\$ctrl.loadingType}}" box-class="{{\$ctrl.loadingClass}}"> </loading-indicator> <div class="contents" ng-if="\$ctrl.isVisible" ng-transclude></div>`;
// Exports
export default code;